<script>
import Layout from "../../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Loading from "@/components/c-loading";
import i18n from "../../../../../i18n";
import { roundingruleService } from "../../../../../services/companyservice/roundingrule.service";


/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Rounding Template",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Rounding template",
      breadCrumb: {},

      rounding: {},
      valueName: '',
      valueMethod: '',
      valueRatio: '',
      valueVariance: 2,

    };
  },
  mounted() {


    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    } 
  },

  methods: {

    loadingData: function(id) {
      this.fetchingStats = false;
      roundingruleService.getOne(id)
        .then(response => {
          
          this.fetchingStats = true;
          this.rounding = response.data;

          this.breadCrumb = {
            text: response.data.name,
            active: true,
          };

          this.valueName = this.rounding.name;
          this.valueMethod = this.rounding.method;
          this.valueRatio = this.rounding.radio;
          this.valueVariance = this.rounding.variance_at;

        });
    },



    submitSave: function() {
      
      this.tryingToSubmit = true;

      let rounding = {
        name: this.valueName,
        method: this.valueMethod,
        ratio: this.valueRatio,
        variance_at: this.valueVariance
      };


      if(this.isAdd) {
        roundingruleService.insert(rounding).then(response => {
          if(response.status == 200) {
            
            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "setting-comapny-round"
                });
              } 
            });

          }
        });
      } else {
        roundingruleService.update(this.$route.params.id, rounding).then(response => {
          if(response.status == 200) {
            
            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "setting-comapny-round"
                });
              } 
            });

          }
        });
      }

    }

  }
};
</script>

<template>
  <Layout>
    <!-- <PageHeader :items="['']" :title="$t('setting.configuration.loan-template.text')" /> -->
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('setting.company.round.text'),
        href: '/setting/company/round',
      }, {
        text: $t('setting.company.round.new'),
        active: true
      }]" :title="this.isAdd ? $t('setting.company.round.new') : $t('setting.company.round.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('setting.company.round.text'),
        href: '/setting/company/round',
      }, this.breadCrumb]" :title="this.isAdd ? $t('setting.company.round.new') : $t('setting.company.round.edit')" />
    </div>
    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'name'"
                    v-model="valueName"
                    :require="true"
                    :label="'setting.company.round.name'"  />
                </div>

                <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'method'"
                    v-model="valueMethod"
                    :label="'setting.company.round.method'"  />
                </div>
              </div>
              <div class="row">
                
                 <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'ratio'"
                    v-model="valueRadio"
                    :label="'setting.company.round.ratio'"  />
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <b-form-group
                        class="mb-3"
                        :label="$t('setting.company.round.variance_at')"
                        :label-for="id"
                    >
                      <div class="input-group" style="margin-left: 10px;"> 
                        <b-form-group class="input-group" id="type">
                          <div inline class="row gy-2 gx-3 align-items-end">
                          <b-form-radio
                            v-model="valueVariance"
                            class="col-sm-auto"
                            value=1
                            plain
                            >First</b-form-radio>
                          <b-form-radio
                            v-model="valueVariance"
                            class="col-sm-auto"
                            value=2
                            plain
                            >Last</b-form-radio>
                          </div>
                        </b-form-group>
                        
                      </div>
                    </b-form-group>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12">

                  <div inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </div>
    
                </div>
              </div>
          
          </div>
        </div>
      </div>
    </b-form> 
  </Layout>
</template>